'use client';
import { IUser, IRepository } from '@/types';

import NewFileForm from '@/components/Repository/NewFileForm';

const CreateFileForm: React.FC<{
  currentUser: IUser;
  repository: IRepository;
  branchName: string;
  resourcePath: string;
}> = ({ currentUser, repository, branchName, resourcePath }) => {
  return (
    <NewFileForm
      user={currentUser as IUser}
      repository={repository as IRepository}
      branch={branchName}
      resourcePath={resourcePath}
      onComplete={({ repository, branch, targetPath, commit }) => {
        window.location.href = `/${repository.namespace}/${repository.name}/file/${branch}/${targetPath}`;
      }}
    />
  );
};

export default CreateFileForm;
